module.exports = __webpack_public_path__ + "img/mermaids.6a09382e.png";